import type { SVGProps } from 'react';

interface AvatarIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const AvatarIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & AvatarIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M11.836 9.333a1.5 1.5 0 0 1 1.5 1.5v.612c0 .382-.12.755-.342 1.066-1.03 1.442-2.714 2.156-4.994 2.156-2.281 0-3.963-.715-4.991-2.158a1.83 1.83 0 0 1-.34-1.064v-.613a1.5 1.5 0 0 1 1.5-1.5zM8 1.336a3.333 3.333 0 1 1 0 6.667 3.333 3.333 0 0 1 0-6.667"
      fill="currentColor"
    />
  </svg>
);
